export class CoreComponentSearch {
    nyomda_id?: number;
}